import script from "./unfinished-order-detail-b.vue?vue&type=script&lang=tsx&setup=true"
export * from "./unfinished-order-detail-b.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__